export const balanceEndpoints = (builder) => ({
    getBalance: builder.query({
        query: () => ({ url: `/orders/zanibal-balance`, method: 'GET' }),
        providesTags: ['Payments'],
    }),
})